export default __webpack_public_path__ + "static/media/1912.d70fffe8.png";